<template>
  <div class="theme-content">
    <div class="block-search flex-row">
      <div class="image-text_2">
        <div class="section_8 flex-row">
          <span class="search-condtion">用户登录</span>
        </div>
        <form class="login-form" action=" https://opac.fudan.edu.cn/" name="form1" target="_blank">
          <div class="login-box">
            <label>证号：</label>
            <input type="hidden" name="func" value="login-session" />
            <input type="hidden" name="bor_library" value="FDU50" /><input type="hidden" name="login_source"
              value="bor-info" />
            <input name="bor_id" class="login-input" />
            <label>密码：</label>
            <input type="password" maxlength="20" name="bor_verification" class="login-input" />
            <input type="submit" value="登录" class="login-btn" />
          </div>
        </form>
      </div>
    </div>
    <img class="image_4" referrerpolicy="no-referrer" src="../../../assets/search-input-bg.png" />
    <div class="theme-info">
      说明：查看个人图书借阅情况、续借预约、修改密码、设定提醒等，也可通过<a href="https://opac.fudan.edu.cn/api/oauth/callback?login=tac_login"
        style="color: #fe9f7f">校园统一身份认证登录</a>。
      <a style="color: #afbdf5" href="https://opac.fudan.edu.cn/fdu_login.html" target="_blank">登录提示</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data () {
    return {
      showForm: false,
      searchValue: "",
      id: 3,
      name: "数据库",
    };
  },
  watch: {
    $route: {
      handler (to) {
        this.isPosition = to.path === "/home";
      },
      immediate: true,
    },
  },
  computed: {
    currentPath () {
      return this.$route.path;
    },
  },
  methods: {
    searchSubmit () {
      if (this.searchValue) {
        let form = document.getElementById("cgForm");
        form.submit();
      }
    },
  },
  mounted () { },
};
</script>

<style scoped lang="scss">
.form-box {
  display: none;
}

.block-search {
  // width: 1228px;
  height: 58px;
  margin-top: 30px;
  background: #fff;

  .section_8 {
    background-color: rgba(0, 72, 150, 1);
    width: 157px;
    height: 57px;
    position: relative;
    cursor: pointer;
  }

  .search-condtion {
    width: 143px;
    height: 22px;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 20px;
    text-align: center;
    white-space: nowrap;
    line-height: 33px;
    margin: 14px 0 0 0;
    padding: 0px 6px;
  }

  .login-form {
    // width: 1000px;
  }

  label {
    font-size: 18px;
    font-weight: 500;
    margin-left: 10px;
  }

  .login-box {
    // width: 700px;
    // margin: auto;
    margin-left: 16px;
  }

  .login-input {
    width: 200px;
    height: 36px;
    line-height: 36px;
    background: 0 0;
    font-size: 18px;
    letter-spacing: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    padding: 0;
    outline: 0;
    padding-left: 10px;
    border-radius: 5px;
    margin-left: 10px;
  }
}

.image-text_2 {
  display: flex;
  align-items: center;
}

.login-btn {
  border: 0;
  height: 36px;
  line-height: 36px;
  text-align: center;
  color: rgba(255, 255, 255, 1);
  font-size: 21px;
  cursor: pointer;
  background-color: rgba(236, 108, 0, 1);
  margin-left: 10px;
  width: 100px;
  border-radius: 5px;
}

.image_4 {
  position: relative;
  // width: 1057px;
  width: 100%;
  height: 2px;
  top: -10px;
  // margin: -10px 0 0 303px;
}

.theme-info {
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  text-align: left;
  line-height: 26px;
  // margin: 0px 0 30px 305px;
}
</style>
